import { on, reducer } from 'ts-action';
import * as undoActions from '../../undo/actions/undo.actions';
import * as signalActions from '../actions/signal.actions';
import * as ecgActions from '../actions/ecg.actions';
import { Signal } from '../types/signal';

declare module 'react-redux' {
  interface DefaultRootState {
    signal: Signal;
  }
}

const initialStateFactory = (): Signal => ({
  frequency: 250,
  leads: {},
});

export default reducer(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(signalActions.loaded, (_state, { signal }): Signal => signal),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { signal } }): Signal => {
      if (!signal) {
        return state;
      }
      return { ...state, ...signal };
    },
  ),
);
